import { formatTestId } from "@nimble/ts-formatters/format-test-ids";

import { schoolHeaderTestIds } from "@/lib/data-test-ids/schools.data-test-ids";

type SchoolDetailPrincipalProps = {
  schoolId: string;
  firstName: string;
  lastName: string;
};

export default function SchoolDetailPrincipal({
  schoolId,
  firstName,
  lastName,
}: SchoolDetailPrincipalProps) {
  const principalName = `${firstName} ${lastName}`;

  return (
    <span
      className="text-sm text-muted-foreground"
      data-testid={`${schoolHeaderTestIds.SCHOOL_PRINCIPAL}-${formatTestId(
        schoolId,
      )}`}
    >
      Principal{" "}
      <span
        className="font-medium text-foreground"
        data-testid={`${schoolHeaderTestIds.SCHOOL_PRINCIPAL_NAME}-${formatTestId(
          schoolId,
        )}`}
      >
        {principalName}
      </span>
    </span>
  );
}
